import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ExcelService } from './components/export-to-excel/excel.service';
import { FileUploadModule } from 'ng2-file-upload';
import { UploadService } from './components/upload-file/uploadService.service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgbTypeaheadConfig, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap'


import {
  ChartistChart,
  AdminPageHeaderComponent,
  AdminSidebarComponent,
  AdminFooterComponent,
  SuperAdminSidebarComponent,
  SuperAdminFooterComponent,
  SuperAdminPageHeaderComponent,
  StaffSidebarComponent,
  StaffFooterComponent,
  StaffPageHeaderComponent,
  EnquiryPageHeaderComponent,
  EnquirySidebarComponent,
  EnquiryFooterComponent,
  LoaderComponent,
  ViewLoaderComponent,
  ChartjsComponent,
  ExportToExcelComponent,
  DisplaySuccessComponent,
  DisplayFailureComponent,
  DisplayPopupFailureComponent,
  UploadComponent,
  DropDownComponent,
  HistorySearchComponent,
  HistoryListComponent,
  HistoryTableRowComponent,
  HistoryExportComponent,
  PaginationComponent
} from './components';


const NGA_COMPONENTS = [
  ChartistChart,
  AdminPageHeaderComponent,
  AdminSidebarComponent,
  AdminFooterComponent,
  SuperAdminSidebarComponent,
  SuperAdminFooterComponent,
  SuperAdminPageHeaderComponent,
  StaffSidebarComponent,
  StaffFooterComponent,
  StaffPageHeaderComponent,
  EnquiryPageHeaderComponent,
  EnquirySidebarComponent,
  EnquiryFooterComponent,
  LoaderComponent,
  ViewLoaderComponent,
  ChartjsComponent,
  ExportToExcelComponent,
  DisplaySuccessComponent,
  DisplayFailureComponent,
  DisplayPopupFailureComponent,
  UploadComponent,
  DropDownComponent,
  HistorySearchComponent,
  HistoryListComponent,
  HistoryTableRowComponent,
  HistoryExportComponent,
  PaginationComponent
];

@NgModule({
  declarations: [
    ...NGA_COMPONENTS
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    BsDatepickerModule.forRoot(),
    NgbTypeaheadModule
  ],
  exports: [
    ...NGA_COMPONENTS
  ],
  providers: [ExcelService, UploadService, NgbTypeaheadConfig]
})
export class NgaModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: NgaModule,
      providers: [
      ]
    };
  }
}
